import Vue from 'vue'
import router from "./router";
import store from "./store/index";
import i18n from "./lang";
import ElementUI from 'element-ui';
import App from './App.vue'
import utils from './utils'
import Tools from "./utils/tools";
Vue.use(Tools);

Vue.prototype.$utils = utils;

// 修复 el-select 在 iOS 中无法触发软键盘的问题
ElementUI.Select.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.DOCUMENT_NODE))
  return !this.filterable && !this.multiple && isIE && !this.visible
}
Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
